<template>
    <div>
        <div class="main-button-bar">
            <el-button type="primary" size="small" @click="showAddDialog">新增店铺</el-button>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 84"
            class="alibaba-shop-table"
        >
            <el-table-column prop="name" label="店铺名称" width="400"></el-table-column>
            <el-table-column prop="shortName" label="店铺简称" width="100"></el-table-column>
            <el-table-column prop="status" label="状态" width="80">
                <template slot-scope="shop">
                    <el-tag type="success" v-if="shop.row.status == 'Y'">可用</el-tag>
                    <el-tag type="danger" v-if="shop.row.status == 'N'">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="account" label="主账号" width="150"></el-table-column>
            <el-table-column prop="secret" label="秘钥" width="500"></el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="shop">
                    <el-button type="text" size="small" v-on:click="edit(shop.row.id)">编辑</el-button>

                    <el-button
                        v-if="shop.row.status == 'Y'"
                        type="text"
                        size="small"
                        v-on:click="upstatus(shop.row.id, 'N')"
                    >禁用</el-button>

                    <el-button
                        v-if="shop.row.status == 'N' || !shop.row.status"
                        type="text"
                        size="small"
                        v-on:click="upstatus(shop.row.id, 'Y')"
                    >启用</el-button>

                    <el-button
                        type="text"
                        size="small"
                        v-on:click="auth(shop.row.id, shop.row.authUser)"
                    >插件授权</el-button>

                    <el-button
                        type="text"
                        size="small"
                        v-on:click="rltSellers(shop.row.id, shop.row.sellers)"
                    >关联业务员</el-button>

                    <el-button type="text" size="small" v-on:click="upsecret(shop.row.id)">修改秘钥</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            :title="shop && shop.id ? '修改店铺' : '新增店铺'"
            :visible.sync="showDialog"
            @closed="refeshRule"
            width="500px"
        >
            <el-form ref="shop" :model="shop" label-width="60px" :rules="rules">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="shop.name"></el-input>
                </el-form-item>

                <el-form-item label="简称" prop="shortName">
                    <el-input v-model="shop.shortName"></el-input>
                </el-form-item>

                <el-form-item label="主账号" prop="account">
                    <el-input v-model="shop.account"></el-input>
                </el-form-item>

                <el-form-item label="密码" prop="password">
                    <el-input v-model="shop.password" type="password"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doAdd">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="插件授权" :visible.sync="showAuth" width="300px">
            <el-select multiple v-model="authUsers" clearable placeholder="选择用户">
                <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doAuth">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="关联业务员" :visible.sync="showSeller" width="300px">
            <el-select multiple v-model="sellers" clearable placeholder="选择用户">
                <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doRltSellers">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDialog: false,
            showAuth: false,
            showSeller: false,
            records: null,
            authUsers: [],
            sellers:[],
            users: [],
            shop: {},
            rules: {
                name: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 64,
                        message: "长度在 2 到 64 个字符",
                        trigger: "blur",
                    },
                ],

                shortName: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 10,
                        message: "长度在 2 到 16 个字符",
                        trigger: "blur",
                    },
                ],

                secret: [
                    { required: true, message: "请输入私钥", trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        showAddDialog() {
            this.shop = {};
            this.showDialog = true;
        },
        edit(id) {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/get", { id: id }],
                [
                    function (data) {
                        _this.shop = data;
                        _this.showDialog = true;
                    },
                ],
                ".op-button"
            );

            this.showDialog = true;
        },
        doAdd() {
            this.$refs["shop"].validate().then(this.doPost);
        },
        doPost() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/save", _this.shop],
                [
                    function (data, msg) {
                        _this.showDialog = false;
                        _this.shop = {};
                        _this.list();
                        msg();
                    },
                ],
                ".op-button"
            );
        },
        list() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/page"],
                [
                    function (data) {
                        _this.records = data;
                    },
                ],
                ".taobao-stop-table"
            );
        },
        upstatus(id, status) {
            this.shop.id = id;
            this.shop.status = status;
            this.doPost();
        },
        upsecret(id) {
            let _this = this;

            _this.$tPrompt.show("输入新秘钥", function (data) {
                _this.shop.id = id;
                _this.shop.secret = data;
                _this.doPost();
            });
        },
        rltSellers(id, users) {
            let _this = this;

            _this.$http.post(
                ["user/listAdress"],
                [
                    function (data) {
                        _this.users = data;

                        if (users) {
                            _this.sellers = [];

                            users.split(",").forEach((data) => {
                                _this.sellers.push(window.parseInt(data));
                            });
                        } else {
                            _this.sellers = [];
                        }

                        _this.shop = {};
                        _this.shop.id = id;
                        _this.showSeller = true;
                    },
                ],
                ".taobao-stop-table"
            );
        },
        auth(id, users) {
            let _this = this;

            _this.$http.post(
                ["user/listAdress"],
                [
                    function (data) {
                        _this.users = data;

                        if (users) {
                            _this.authUsers = [];

                            users.split(",").forEach((data) => {
                                _this.authUsers.push(window.parseInt(data));
                            });
                        } else {
                            _this.authUsers = [];
                        }

                        _this.shop = {};
                        _this.shop.id = id;
                        _this.showAuth = true;
                    },
                ],
                ".taobao-stop-table"
            );
        },
        doAuth() {
            let _this = this;

            _this.shop.authUser = _this.authUsers.join(",");

            _this.$http.post(
                ["alibaba/shop/save", _this.shop],
                [
                    function () {
                        _this.showAuth = false;
                        _this.shop = {};
                        _this.list();
                    },
                ],
                ".op-button"
            );
        },
        doRltSellers() {
            let _this = this;

            _this.shop.sellers= _this.sellers.join(",");

            _this.$http.post(
                ["alibaba/shop/save", _this.shop],
                [
                    function () {
                        _this.showSeller = false;
                        _this.shop = {};
                        _this.list();
                    },
                ],
                ".op-button"
            );
        },
        refeshRule() {
            this.shop = {};
            this.$refs["shop"].resetFields();
        },
    },
    mounted() {
        this.list();
    },
};
</script>

<style lang="scss">
</style>